import { Icon } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { Nav } from '../../Shared/components-v2/nav/nav';

type Props = {
  href: string;
  icon: 'Mail' | 'Phone' | 'Calendar';
  contactInfo: string;
  target?: string;
  rel?: string;
};

export function AdvisorContactLink(props: Props) {
  const { href, contactInfo, icon, target, rel } = props;

  return (
    <SambaAutoLink
      to={href}
      css={{
        color: 'currentColor',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridColumnGap: 'space.150',
        pt: 'space.150',
        alignItems: 'center',
        _hover: { color: 'currentColor' },
        _focus: { color: 'currentColor' },
        _active: { color: 'currentColor' },
      }}
      target={target}
      rel={rel}
    >
      <Icon data-testid="icon" name={icon} color="icon.onPrimary" size="small" />
      <Nav.Text>{contactInfo}</Nav.Text>
    </SambaAutoLink>
  );
}
